import React, { FunctionComponent } from "react";
import { Typography } from "@material-ui/core";

type Property = {
  id: string;
}

export const FootnoteRef: FunctionComponent<Property> = (props) =>(
  <Typography variant="body1" component="span">
    [{props.children}]
    <a id={props.id} />
  </Typography>
);